import { defineComponent as u, openBlock as t, createElementBlock as a, mergeProps as i, unref as o, renderSlot as g, createElementVNode as e, createCommentVNode as m } from "vue";
import { useScalarIcon as Z } from "../hooks/useScalarIcon.js";
const M = { key: 0 }, f = { key: 1 }, k = { key: 2 }, h = { key: 3 }, w = { key: 4 }, y = { key: 5 }, L = {
  name: "ScalarIconCaretDoubleLeft"
}, b = /* @__PURE__ */ u({
  ...L,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = Z(s);
    return (p, l) => (t(), a("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(d)), [
      g(p.$slots, "default"),
      o(n) === "bold" ? (t(), a("g", M, l[0] || (l[0] = [
        e("path", { d: "M208.49,199.51a12,12,0,0,1-17,17l-80-80a12,12,0,0,1,0-17l80-80a12,12,0,0,1,17,17L137,128ZM57,128l71.52-71.51a12,12,0,0,0-17-17l-80,80a12,12,0,0,0,0,17l80,80a12,12,0,0,0,17-17Z" }, null, -1)
      ]))) : o(n) === "duotone" ? (t(), a("g", f, l[1] || (l[1] = [
        e("path", {
          d: "M200,48V208l-80-80Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M203.06,40.61a8,8,0,0,0-8.72,1.73l-80,80a8,8,0,0,0,0,11.32l80,80A8,8,0,0,0,208,208V48A8,8,0,0,0,203.06,40.61ZM192,188.69,131.31,128,192,67.31Zm-66.34,13.65a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L51.31,128Z" }, null, -1)
      ]))) : o(n) === "fill" ? (t(), a("g", k, l[2] || (l[2] = [
        e("path", { d: "M208,48V208a8,8,0,0,1-13.66,5.66L128,147.31V208a8,8,0,0,1-13.66,5.66l-80-80a8,8,0,0,1,0-11.32l80-80A8,8,0,0,1,128,48v60.69l66.34-66.35A8,8,0,0,1,208,48Z" }, null, -1)
      ]))) : o(n) === "light" ? (t(), a("g", h, l[3] || (l[3] = [
        e("path", { d: "M204.24,203.76a6,6,0,1,1-8.48,8.48l-80-80a6,6,0,0,1,0-8.48l80-80a6,6,0,0,1,8.48,8.48L128.49,128ZM48.49,128l75.75-75.76a6,6,0,0,0-8.48-8.48l-80,80a6,6,0,0,0,0,8.48l80,80a6,6,0,1,0,8.48-8.48Z" }, null, -1)
      ]))) : o(n) === "regular" ? (t(), a("g", w, l[4] || (l[4] = [
        e("path", { d: "M205.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L131.31,128ZM51.31,128l74.35-74.34a8,8,0,0,0-11.32-11.32l-80,80a8,8,0,0,0,0,11.32l80,80a8,8,0,0,0,11.32-11.32Z" }, null, -1)
      ]))) : o(n) === "thin" ? (t(), a("g", y, l[5] || (l[5] = [
        e("path", { d: "M202.83,205.17a4,4,0,0,1-5.66,5.66l-80-80a4,4,0,0,1,0-5.66l80-80a4,4,0,1,1,5.66,5.66L125.66,128ZM45.66,128l77.17-77.17a4,4,0,0,0-5.66-5.66l-80,80a4,4,0,0,0,0,5.66l80,80a4,4,0,1,0,5.66-5.66Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  b as default
};
